<div class="zk-mb-8" *ngIf="formGroup">
	<div class="field">
		<div class="info-row zk-mb-2">
			<div class="wrap-group">
				<div class="field__label">{{ 'PROMPTUARY.OUTCOME' | translate }}*</div>
				<div class="subinfo">
					{{ 'PROMPTUARY.OUTCOME_H2' | translate }}
				</div>
			</div>
		</div>
		<div class="wrap-group">
			<div class="field__label">
				{{ 'PROMPTUARY.SELECT_AN_OPTION' | translate }}
			</div>
		</div>
		<freud-select
			[options]="outcomeOptions"
			[placeholder]="'PROMPTUARY.OUTCOME_PLACEHOLDER' | translate"
			[formControl]="formGroup.get('outcome')"
			optionValue="value"
			(onChange)="onOutcomeChange($event)"
		></freud-select>
	</div>

	<div
		class="field"
		*ngIf="
			formGroup.get('outcome').value ===
				'Encaminhamento de plano de cuidados' &&
			outcomeForwardJourneyOptions.length > 0
		"
	>
		<div class="wrap-group">
			<div class="field__label zk-mt-2">
				{{ 'PROMPTUARY.JOURNEY_SETTING' | translate }}*
			</div>
			<div class="subinfo" *ngIf="companyName">
				{{ 'PROMPTUARY.JOURNEY_SETTING_DESCRIPTION' | translate }}
				<span class="employee-info">{{
					'PROMPTUARY.JOURNEY_COMPANY_EMPLOYEE'
						| translate: { companyName: this.companyName }
				}}</span>
			</div>
		</div>

		<div class="zk-flex zk-justify-between zk-gap-3">
			<div class="field zk-flex-1 outcome-forward-journey">
				<div class="info-row zk-mb-3">
					<div class="wrap-group">
						<div class="field__label zk-mt-2">
							{{ 'PROMPTUARY.SELECT_A_JOURNEY' | translate }}*
						</div>
					</div>
				</div>
				<div>
					<freud-select
						[useItemTemplate]="true"
						[formControl]="formGroup.get('outcomeForwardJourney')"
						[placeholder]="'PROMPTUARY.OUTCOME_PLACEHOLDER' | translate"
						[options]="outcomeForwardJourneyOptions"
						optionValue="value"
						(onChange)="
							onFowardJourneyChange($event);
							onChange.emit({
								field: 'outcomeForwardJourney',
								value: $event.value
							})
						"
					></freud-select>
				</div>
			</div>
			<div
				class="field outcome-number-sessions"
				*ngIf="numberOfJourneySessionsOptions.length > 0"
			>
				<div class="info-row zk-mb-3">
					<div class="wrap-group">
						<div class="field__label zk-mt-2">
							{{ 'PROMPTUARY.JOURNEY_NUMBER_OF_SESSIONS' | translate }}*
						</div>
					</div>
				</div>
				<freud-select
					[formControl]="formGroup.get('outcomeForwardJourneySessionNumber')"
					[options]="numberOfJourneySessionsOptions"
					optionValue="value"
					placeholder="Selecione a quantidade"
					[disabled]="numberOfJourneySessionsOptions.length === 1"
					(onChange)="
						onChange.emit({
							field: 'outcomeForwardJourneySessionNumber',
							value: $event.value
						})
					"
				>
				</freud-select>
			</div>
		</div>
		<div
			class="outcome-journey-confirmation"
			*ngIf="formGroup.get('outcomeForwardJourney').value"
		>
			<span class="plan-content">{{
				'PROMPTUARY.OUTCOME_PLAN_CONTENT' | translate
			}}</span>
			<span class="outcome-tags" *ngFor="let tag of selectedOnFowardJourneyTags"
				>{{ tag.label }}
				{{
					tag.value == 'therapy' &&
					numberOfJourneySessionsOptions.length !== 1 &&
					formGroup.get('outcomeForwardJourneySessionNumber').value
						? '(' +
						  formGroup.get('outcomeForwardJourneySessionNumber').value +
						  ')'
						: ''
				}}</span
			>
		</div>
	</div>

	<div *ngIf="formGroup.get('outcome').value === 'Encaminhamento especialista'">
		<div class="field">
			<div class="info-row">
				<div class="wrap-group zk-flex zk-items-center zk-mt-3">
					<div class="field__label">
						{{ 'PROMPTUARY.WHATS_SPECIALTY' | translate }}*
					</div>
					<div 
						freud-tooltip 
						class="zk-flex zk-items-center zk-ml-1" 
						[tooltipLabel]="'PROMPTUARY.WHATS_SPECIALTY_TOOLTIP' | translate" 
						tooltipPosition="top"
					>
							<span class="freud-icon freud-icon-info-circle freud-icon-xs zk-flex zk-items-center icon-size"></span>
					</div>
				</div>
			</div>
			<freud-select
				[formControl]="formGroup.get('outcomeSpecialty')"
				[options]="specialtyOptions"
				[placeholder]="'PROMPTUARY.WHATS_SPECIALTY_PLACEHOLDER' | translate"
				optionValue="value"
				(onChange)="onSpecialtyChange($event)"
				ngDefaultControl
			></freud-select>
		</div>

		<ng-container *ngIf="this.formGroup.get('outcomeSpecialty').value === 'others'">
			<div class="field zk-mt-4">
				<div class="info-row">
					<div class="wrap-group">
						<div class="field__label">
							{{ 'PROMPTUARY.WHATS_SPECIALTY_OTHER' | translate }}
						</div>
					</div>
				</div>
				<autosave-textarea
					ngDefaultControl
					id="outcome-other-specialty"
					[placeholder]="'PROMPTUARY.WHATS_SPECIALTY_OTHER_PLACEHOLDER' | translate"
					property="outcomeOtherSpecialty"
					[formControl]="formGroup.get('outcomeOtherSpecialty')"
					service="autoSaveField"
					[appointment]="autoSaveData"
					[appointmentData]="appointment"
					[rows]="1"
					(valueChanged)="onSaving.emit('outcomeOtherSpecialty')"
					(valueSaved)="onSaved.emit('outcomeOtherSpecialty')"
				></autosave-textarea>
			</div>
		</ng-container>
	</div>
</div>
